module.exports = __webpack_public_path__ + "img/specs-box.9c4331ce.svg";